import React from "react";
import { useUIVersion } from "../../contexts/UIVersionContext";
import TrackerShell from "../tracker/TrackerShell";
import "../../styles/tracker-base.css";
import "./tracker-container.css";

/**
 * Enhanced TrackerContainer component with UI 2.0 support
 * 
 * This component wraps the existing TrackerShell and adds:
 * - UI 2.0 feature detection
 * - Enhanced styling when modern trackers are enabled
 * - Conditional rendering for new features
 * - Backward compatibility with legacy trackers
 */
export default function TrackerContainer({ 
  title, 
  left, 
  right, 
  children, 
  trackerType = "generic",
  totalCount = null,
  showFilters = false,
  filterComponent = null 
}) {
  const { isFeatureEnabled } = useUIVersion();
  
  const modernTrackersEnabled = isFeatureEnabled('modernTrackers');
  const modernFiltersEnabled = isFeatureEnabled('modernTrackerFilters');

  // For legacy mode, use the original TrackerShell
  if (!modernTrackersEnabled) {
    return (
      <TrackerShell title={title} left={left} right={right}>
        {children}
      </TrackerShell>
    );
  }

  // Modern tracker UI with enhanced features
  return (
    <div className={`tracker-page ${modernTrackersEnabled ? 'modern-tracker' : ''}`}>
      <div className="tracker-card modern">
        {/* Enhanced toolbar with optional total count */}
        <div className="tracker-toolbar modern">
          <div className="left">
            <div className="tracker-title modern">{title}</div>
            {totalCount !== null && (
              <div className="tracker-total-count">
                {totalCount}
              </div>
            )}
            {left}
          </div>
          <div className="right" style={{ gridColumn: "3 / 4" }}>
            {right}
          </div>
        </div>

        {/* Optional filters bar */}
        {showFilters && modernFiltersEnabled && filterComponent && (
          <div className="tracker-filters-bar">
            {filterComponent}
          </div>
        )}

        {/* Enhanced viewport with modern styling */}
        <div className={`tracker-viewport ${modernTrackersEnabled ? 'modern' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
}